export default "__VITE_ASSET__UhIlaL5U__"